/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { featuresGet } from "../funcs/featuresGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ProductFeatures } from "../models/components/productfeatures.js";
import {
  GetProductFeaturesRequest,
  GetProductFeaturesSecurity,
} from "../models/operations/getproductfeatures.js";
import { unwrapAsync } from "../types/fp.js";
export type ProductFeaturesQueryData = ProductFeatures;

export function prefetchProductFeatures(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetProductFeaturesRequest,
  security?: GetProductFeaturesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildProductFeaturesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildProductFeaturesQuery(
  client$: GramCore,
  request: GetProductFeaturesRequest,
  security?: GetProductFeaturesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ProductFeaturesQueryData>;
} {
  return {
    queryKey: queryKeyProductFeatures({
      organizationId: request.organizationId,
      gramSession: request.gramSession,
    }),
    queryFn: async function productFeaturesQueryFn(
      ctx,
    ): Promise<ProductFeaturesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(featuresGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyProductFeatures(
  parameters: { organizationId: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "features", "get", parameters];
}
